import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";

export default function AdminBookings() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/bookings", { params: status ? { status } : {} });
      setRows(data);
    } catch (e) { toast.error(errMsg(e, "Load failed")); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [status]);

  return (
    <div className="mx-auto max-w-6xl">
      <div className="flex items-end justify-between">
        <div>
          <span className="kbd-eyebrow">Admin</span>
          <h1 className="mt-3 font-serif-display text-3xl font-semibold text-secondary">Bookings</h1>
        </div>
        <select data-testid="admin-bookings-filter" value={status} onChange={(e) => setStatus(e.target.value)}
                className="rounded-full border border-border/70 bg-background px-4 py-2 text-xs font-semibold text-secondary">
          <option value="">All statuses</option>
          <option value="confirmed">Confirmed</option>
          <option value="payment_pending">Payment pending</option>
          <option value="in_progress">In progress</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
          <option value="expired">Expired</option>
        </select>
      </div>

      <div className="mt-8 overflow-hidden rounded-2xl border border-border/70 bg-card" data-testid="admin-bookings-table">
        <table className="w-full text-sm">
          <thead className="border-b border-border/70 bg-muted/50 text-left text-[11px] font-semibold uppercase tracking-[0.16em] text-muted-foreground">
            <tr>
              <th className="px-4 py-3">Ref</th>
              <th className="px-4 py-3">Created</th>
              <th className="px-4 py-3">Event</th>
              <th className="px-4 py-3">Package</th>
              <th className="px-4 py-3">Guests</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Payment</th>
              <th className="px-4 py-3 text-right">Final ₹</th>
              <th className="px-4 py-3 text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={9} className="px-4 py-6 text-center text-muted-foreground">Loading…</td></tr>}
            {!loading && rows.length === 0 && <tr><td colSpan={9} className="px-4 py-8 text-center text-muted-foreground" data-testid="admin-bookings-empty">No bookings.</td></tr>}
            {rows.map((b) => (
              <tr key={b.id} data-testid={`admin-booking-row-${b.reference}`} className="border-b border-border/60 last:border-none">
                <td className="px-4 py-3 font-mono text-xs text-secondary">{b.reference}</td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{(b.created_at || "").slice(0, 16).replace("T", " ")}</td>
                <td className="px-4 py-3">{b.event_type || "—"} {b.event_date || ""}</td>
                <td className="px-4 py-3">{b.package_snapshot?.name || "—"}</td>
                <td className="px-4 py-3">{b.guest_count || "—"}</td>
                <td className="px-4 py-3"><span className="rounded-full bg-muted px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em]">{b.status}</span></td>
                <td className="px-4 py-3 text-xs">{b.payment_status}</td>
                <td className="px-4 py-3 text-right">{b.final_amount != null ? `₹${Number(b.final_amount).toLocaleString("en-IN")}` : "—"}</td>
                <td className="px-4 py-3 text-right">
                  <Link data-testid={`admin-booking-view-${b.reference}`} to={`/admin/bookings/${b.id}`} className="text-xs font-semibold uppercase tracking-[0.14em] text-primary hover:underline">Open</Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
